<template>
  <div>
    <Title v-if="!isAdmin" :showMinister="true" :showService="true" />
    <Breadcrumb :links="breadCrumbData" />
    <Carrusel />

    <div v-if="permission">
      <Main

      />
    </div>
    <div v-else><NotPermision :contenido="contenidoLock" /></div>
  </div>
</template>

<script>
import Title from "../../../components/private/Title";
import Breadcrumb from "@/components/tools/Breadcrumb.vue";
import { mapState } from "vuex";
import Carrusel from "../../../components/private/Carrusel.vue";
import Main from "./Main.vue";
import NotPermision from "@/components/private/TextNotPermisionPrueba.vue";
import axios from "axios";
export default {
  components: {
    Title,
    Breadcrumb,
    Carrusel,
    Main,
    NotPermision,
  },
  data() {
    return {
      permission: false,
      breadCrumbData: null,
      contenidoLock: null,
    };
  },
  computed: {
    ...mapState("sesion", ["usuario"]),
    isAdmin: function() {
      return this.usuario.username === process.env.VUE_APP_USER_ADMIN;
    },
  },
  methods: {
    setBreadcrumbData: function() {
      this.breadCrumbData = [
        {
          name: "Portada BGI",
          routeName: "bgi",
          routeParams: {
            idUsuario: this.usuario.id,
          },
        },
        {
          name: "Escritorio de Gestión Virtual",
          routeName: "buttons",
          routeParams: {
            idUsuario: this.usuario.id,
            idServicio: this.$route.params.idServicio,
          },
        },
        {
          name: "Premios y Reconocimientos",
          routeName: "informeprograma",
          routeParams: {
            idServicio: this.$route.params.idServicio,
          },
        },
      ];
    },
    obtenerRelacionUsuarioServicio() {
      const data = JSON.parse(localStorage.getItem("user"));
      const relacionUs = data.servicios.find(
        (s) => s.id === parseInt(this.$route.params.idServicio)
      );
      if (!relacionUs) return;
      if (
        relacionUs.permisos.find((p) => p.permisoId === 14) ||
        relacionUs.rolId === 3 ||
        relacionUs.rolId === 4 ||
        relacionUs.rolId === 5
      ) {
        this.permission = true;
      }
    },
    obtenerContenido: async function() {
      try {
        const obj = {
          anio: process.env.VUE_APP_ANIO,
          nombre: "premios_reconocimientos",
        };
        const res = await axios.get(
          `${process.env.VUE_APP_RUTA_API}/instituciones/secciones/${this.$route.params.idServicio}/?anio=${obj.anio}&nombre=${obj.nombre}`,
          {
            headers: {
              Authorization: `JWT ${localStorage.getItem("userToken")}`,
            },
          }
        );
        this.checked = res.data.info.aplica;

        if (res.data.info.content) {
          this.contenidoLock = res.data.info.content;
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
  mounted() {
    this.setBreadcrumbData();
    this.obtenerRelacionUsuarioServicio();
    this.obtenerContenido();
  },
};
</script>
